<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-4 class="text-left fw-500">4. Deposits and Withdrawals</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-4" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Deposits: Deposits can be made via bank transfer, credit card, or other methods approved by RCPAY Virtual Account.</li>
                        <li>Withdrawals: Withdrawals may be subject to limits and require authentication as specified by RCPAY Virtual Account.</li>
                        <li>Fees: RCPAY Virtual Account may impose fees on deposits and withdrawals, which will be communicated to the Account Holder in advance.</li>
                        <li>Processing Time: Deposits and withdrawals will be processed within the timeframes specified by RCPAY Virtual Account, subject to any delays caused by external factors beyond our control.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-4',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>